import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';

import APDropdown from 'components/Dropdown/APDropdown';

/**
 * @description: CountControl Component for Leads Table
 * @param {*}
 * @return {*}
 */
export const CountControl = ({ options, selected = '', onChange }) => {
  const [showOption, setShowOption] = useState(false);
  const [count, setCount] = useState(selected);

  useEffect(() => {
    if (selected) setCount(selected);
  }, [selected]);

  const onViewOptionClick = () => {
    setShowOption(!showOption);
  };

  const closeOptions = () => {
    setShowOption(false);
  };

  const handleClick = (number) => {
    setCount(number);
    onChange(number);
    closeOptions();
  };

  const trigger =  (
    <div className="pager__count-control count-control">
      <button
        id="count-control-trigger"
        className="d-flex align-items-center button--unstyled"
        onClick={onViewOptionClick}
      >
        <div>{count} per page</div>
        {showOption ? <MdKeyboardArrowUp size={14} /> : <MdKeyboardArrowDown size={14} />}
      </button>
    </div>
  );

  const children = (
    <section className="count-control__options ap-dropdown__content up">
      {options.map(option => {
        return (
          <button
            key={`select-${option}`}
            className={clsx('count-control__item', 'button--unstyled', 'text--unstyled', {
              'count-control__button--active': option === count,
            })}
            onClick={() => handleClick(option)}
          >
            {option} per page
          </button>
        );
      })}
    </section>
  );
  return (
    <APDropdown
      isOpen={showOption}
      show={() => setShowOption(true)}
      dismiss={() => setShowOption(false)}
      triggerButton={trigger}
      children={children}
      placement='top-start'
      hasArrow
      menuClass='pager-dropdown__content'
    />
  );
};
